




















































import Vue from 'vue'
import { cloneDeep } from 'lodash'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'

interface LanguageListItem {
  id: number
  code: string
  text: string
}

interface ComponentData {
  multiLanguagesDialogData: LanguageListItem[]
  isTabs: boolean
  tab: number
  areaHeight: number
}

export default Vue.extend({
  name: 'MultiLanguagesDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedField: {
      type: Object as () => AdditionalField
    },
    dialogData: Array as () => LanguageListItem[],
    isTextArea: Boolean,
    profitCenterMultiLanguageLoading: Boolean
  },

  data (): ComponentData {
    return {
      multiLanguagesDialogData: [],
      isTabs: false,
      tab: 0,
      areaHeight: 200
    }
  },

  watch: {
    isTabs (newVal: boolean): void {
      if (newVal) {
        this.areaHeight = (this.$refs.cardText as HTMLElement).clientHeight - 72
      }
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.$emit('saveMultiLanguageList', this.multiLanguagesDialogData)
    }
  },

  mounted () {
    this.multiLanguagesDialogData = cloneDeep(this.dialogData)
  }
})
